import React from 'react';

import {
  BaseWidget,
  PermissionWall,
  RefundDetailModal
} from 'modules/layer01';
import {
  styled,
  Box,
  Button
} from '@mui/material';

import { Timeline } from 'modules/layer00';
import { modalUtil } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const ContainerBox = styled(Box)({
  minWidth: 288
});

export interface IProps {
  storeId: string;
  returnAuthorizationId: string;
  variant: 'customer' | 'partner';
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.usePartnerQuery(props.returnAuthorizationId, props.variant === 'customer');
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'refundDetail'
  ]);



  function handleClickShowRefund() {
    setModalIsOpen('refundDetail', true);
  }

  function handleCloseRefundDetail() {
    setModalIsOpen('refundDetail', false);
  }

  return (
    <>
      <ContainerBox>
        <BaseWidget.FC>
          <Timeline.FC steps={queryTuple.data.steps} />

          {props.variant !== 'customer' && queryTuple.data.refundStatus === 'approved' && (
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['refund_view']}>
              <Button onClick={handleClickShowRefund}>
                Show refund
              </Button>
            </PermissionWall.FC>
          )}
        </BaseWidget.FC>
      </ContainerBox>

      {modalType2IsOpen.refundDetail && (
        <RefundDetailModal.FC
          refundId={queryTuple.data.refundId}
          onClose={handleCloseRefundDetail} />
      )}
    </>
  );
};

